module.exports = __webpack_public_path__ + "img/q1.9d902599.png";